import { render } from "./PerformanceManagementPage.vue?vue&type=template&id=39ff8b04&scoped=true"
import script from "./PerformanceManagementPage.vue?vue&type=script&lang=js"
export * from "./PerformanceManagementPage.vue?vue&type=script&lang=js"

import "./PerformanceManagementPage.vue?vue&type=style&index=0&id=39ff8b04&scoped=true&lang=css"

import exportComponent from "F:\\omar pos 2\\pos_administration_platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39ff8b04"]])

export default __exports__